export default __webpack_public_path__ + "static/media/Depot.af186dc1.png";